import { render, staticRenderFns } from "./ListCatalog.vue?vue&type=template&id=4b4e60d0&scoped=true"
import script from "./ListCatalog.vue?vue&type=script&lang=js"
export * from "./ListCatalog.vue?vue&type=script&lang=js"
import style0 from "./ListCatalog.vue?vue&type=style&index=0&id=4b4e60d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e60d0",
  null
  
)

export default component.exports